import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import AudioPlayer from "../../components/UploadAudio/AudioPlayer";
import { useRef } from "react";

export default function ViewRap({ openBattleView, handleClose, selectedItem }) {
  const audioRef = useRef(new Audio(selectedItem?.audio));

  const handleCloseDialog = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    handleClose();
  };
  return (
    <Dialog
      open={openBattleView}
      onClose={handleCloseDialog}
      maxWidth="sm"
      fullWidth // Ensures the dialog uses the full width of maxWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "100%",
          maxWidth: "500px",
        },
      }}
    >
      <DialogTitle style={{ fontSize: "20px", width: "200px", color: "black" }}>
        Audio Details
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ fontSize: "18px" }} mb={1}>
          Title: <span style={{ fontWeight: 400 }}>{selectedItem?.name}</span>
        </Typography>
        {/* Show category logo */}
        {selectedItem.image ? (
          <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Typography variant="body1" sx={{ fontSize: "18px" }}>
              Thumbnail:&nbsp;
            </Typography>
            <img
              src={selectedItem.image}
              alt="Category Logo"
              style={{
                maxWidth: "100px",
                maxHeight: "100px",
                objectFit: "contain",
              }}
            />
          </Box>
        ) : (
          <Typography variant="body1">No Logo</Typography>
        )}
        <Typography
          variant="body1"
          sx={{ fontSize: "18px", marginTop: "16px" }}
        >
          Audio Source:
        </Typography>
        <Box sx={{ mt: 1 }}>
          <AudioPlayer audioRef={audioRef} openDialog={open} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
